import Vue from "vue";
import Vuetify from "vuetify/lib";

import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.lightBlue.darken4,
        secondary: "#4caf50",
        tertiary: "#495057",
        accent: "#82B1FF",
        error: colors.red.darken4,
        info: "#00d3ee",
        success: "#5cb860",
        warning: "#ffa21a",
        messageBubble: "#A1B6F7",
        cleed_blue: "#1141ce",
      },
    },
  },
  icons: {
    iconfont: "mdi",
  },
});
